import Vue from 'vue'

import i18n from "@/messages"

import moment from 'moment';

moment.locale('cs-CZ');
moment.updateLocale('cs-CZ', {
    months: {
        standalone: 'ledna_února_březena_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split('_'),
        format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_')
    }
});

import formatters from "@/plugins/formattersMixin.js"

const filters = {
    capitalize(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    upper(value) {
        if (!value) return ''
        return value.toUpperCase()
    },
    lower(value) {
        if (!value) return ''
        return value.toLowerCase()
    },
    integer(value, def = '') {
        if (!value) return def
        return Number.parseInt(value)
    },
    division(dividend, divisor) {
        if (!dividend) return ''
        return Number.parseFloat(dividend / divisor).toFixed(1)
    },
    millions(value) {
        if (!value) return ''
        return Vue.filter('division')(value, 1.0e+6)
    },
    thousands(value) {
        if (!value) return ''
        return Vue.filter('division')(value, 1.0e+3)
    },
    date(value) {
        if (!value) return ''
        return moment(value).format("D. MMMM YYYY")
    },
    datetime(value) {
        if (!value) return ''
        return moment(value).format("D. MMMM YYYY H:mm")
    },
    humanizePrice(value) {
        var price = "0"
        if (value >= 1e+6) {
            var milions = Math.round(Vue.filter('millions')(value))
            price = Vue.filter('number')(milions) + " " + i18n.tc("currency.millions", Vue.filter('number')(milions))
        } else if (value > 0) {
            price = Vue.filter('number')(Vue.filter('integer')(value))
        }

        return price + " " + i18n.global.t("currency.czk")
    },
    price(value) {
        return formatters.methods.formatNumber(Number.parseFloat(value)) + " " + i18n.global.t("currency.czk")
    },
    formatDate(value, format) {
        return moment(value).format(format)
    }
}

export const FILTERS = filters;
